import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { cleanup, render, screen } from '@testing-library/react';
import * as React from 'react';
import { Provider } from 'react-redux';

import MuiXLicense from '../../../licensing/MuiXLicense';
import redux from '../../redux';
import BulkPauseUnpauseModal from './index';

function TestComponent() {
  return (
    <>
      <Provider store={redux.store}>
        <LocalizationProvider adapterLocale="en" dateAdapter={AdapterDayjs}>
          <BulkPauseUnpauseModal
            customer_group_id={100}
            customer_id={1}
            userTimezone="America/Toronto"
          />
        </LocalizationProvider>
      </Provider>
      <MuiXLicense />
    </>
  );
}

describe('bulk pause unpause modal', () => {
  afterEach(() => {
    cleanup();
  });

  test('should render the bulk pause unpause modal', () => {
    redux.store.dispatch(redux.modal.open());
    render(<TestComponent />);
    const modal = screen.getByTestId('bulk-pause-unpause-modal');
    expect(modal).toBeDefined();
  });
});
